import { useRouter } from 'next/router'

import { useTranslatedLocalization } from '../../../app/_hooks/useTranslatedLocalization'
import { useFixturesContext } from '../../../brunswick/containers/fixtures/FixturesContext'

import { useRegionLocaleTab } from './RegionLocaleTab/useRegionLocaleTab'
import { useAccountTab } from './useAccountTab'
import { useCartTab } from './useCartTab'
import { useFavoritesTab } from './useFavoritesTab'
import { useSearchTab } from './useSearchTab'

export const useIconTabs = () => {
  const { pathname } = useRouter()
  const fixtures = useFixturesContext()
  const translatedLocalization = useTranslatedLocalization(fixtures)
  const isSearchPage: boolean = pathname === '/search'

  const searchTab = useSearchTab()
  const accountTab = useAccountTab()
  const favoritesTab = useFavoritesTab()
  const cartTab = useCartTab()
  const localeTab = useRegionLocaleTab()
  const mobileIconTabs = [accountTab, cartTab]
  const desktopIconTabs =
    translatedLocalization.data.region.languagesArray.length > 1
      ? [searchTab, localeTab, accountTab, favoritesTab, cartTab].filter(tab => tab !== null)
      : [searchTab, ...mobileIconTabs]
  if (isSearchPage) desktopIconTabs.shift()

  return {
    desktopIconTabs,
    mobileIconTabs,
  }
}
